import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { OTA_IDS } from 'frontend-utils/utils/constants/constant-values';

export default class ConnectedOta extends Model {
  [Type] = 'reviews/connected-ota' as const;

  @attr('string') declare name: string;
  @attr('string')
  declare otaId: typeof OTA_IDS.BOOKINGDOTCOM | typeof OTA_IDS.EXPEDIA;
  @attr('string') declare propertyId: string;
}
